import { ZoomMeetingList } from "./ZoomMeetingList";
import { ZoomMeetingShow } from "./ZoomMeetingShow";

export default {
  list: ZoomMeetingList,
  show: ZoomMeetingShow,
};
